import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DetailFieldText from 'fixedassets/components/detail/field/DetailFieldText';

const DetailFieldRelation = ({ label, value, t }) => (
  <DetailFieldText label={label} value={value ? `${t(value.key)} - ${t(value.name)}` : null} />
);

DetailFieldRelation.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

export default translate()(DetailFieldRelation);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/DetailFieldRelation.js